export default "__VITE_ASSET__B2R6z$9L__"